import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgOtpInputModule } from 'ng-otp-input';
import { PasswordModule } from 'primeng/password';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DragDropService } from './services/drag-drop.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BreadcrumbModule } from 'xng-breadcrumb';
import * as Sentry from '@sentry/angular';

// Custom Modules 
import { JobModule } from './job/job.module';
import { SharedModule } from './shared/shared.module';
import { EventsModule } from './events/events.module';
import { RolesModule } from './roles/roles.module';
import { UserModule } from './user/user.module';
import { EmailModule } from './email/email.module';
import { SettingsModule } from './settings/settings.module';
import { AppRoutingModule } from './app-routing.module';
import { CopilotModule } from './copilot/copilot.module';
import { FormModule } from './form-builder/form.module';
import { FormBuilderModule } from './form-builder/form-builder.module';
import { LoginCallbackModule } from './login-call-back/login-callback.module';

//custom Componenets
import { AppComponent } from './app.component';
import { JobListComponent } from './job-list/job-list.component';
import { HeaderComponent } from './header/header.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { TalentpoolManagementComponent } from './talentpool/talentpool-management/talentpool-management.component';
import { CandidatePanelComponent } from './candidate-panel/candidate-panel.component';
import { LoginOtpVerificationComponent } from './login-otp-verification/login-otp-verification.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { AuthenticationCarouselComponent } from './authentication-carousel/authentication-carousel.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { SpotlightSearchComponent } from './spotlight-search/spotlight-search.component';
import { MaintenanceV2Component } from './maintenance/maintenance-v2.component';
import { TitleCaseUnderscorePipe } from './pipes/titleCaseUnderscore.pipe';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { providePrimeNG } from 'primeng/config';
import AppPreset from './app-preset';
import { DrawerModule } from 'primeng/drawer';
import { PopoverModule } from 'primeng/popover';
import { Select } from "primeng/select";
import { InviteCandidateV2Component } from "./talentpool/invite-candidate-v2/invite-candidate-v2";

@NgModule({
    declarations: [
        AppComponent,
        JobListComponent,
        HeaderComponent,
        SideNavComponent,
        DashboardComponent,
        LoginComponent,
        TalentpoolManagementComponent,
        CandidatePanelComponent,
        LoginOtpVerificationComponent,
        ErrorPageComponent,
        MaintenanceComponent,
        MaintenanceV2Component,
    ],
    bootstrap: [AppComponent],
    imports: [
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    JobModule,
    UserModule,
    NgxDropzoneModule,
    EmailModule,
    EventsModule,
    RolesModule,
    PasswordModule,
    NgOtpInputModule,
    SettingsModule,
    CopilotModule,
    FormModule,
    ConfirmPopupModule,
    FormBuilderModule,
    ProgressSpinnerModule,
    LoginCallbackModule,
    BreadcrumbModule,
    AuthenticationCarouselComponent,
    SpotlightSearchComponent,
    TitleCaseUnderscorePipe,
    DrawerModule,
    PopoverModule,
    Select,
    InviteCandidateV2Component
],
    providers: [
        MessageService,
        ConfirmationService,
        DragDropService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
                logErrors: false
            }),
        },
        {
            provide: Sentry.TraceService,
            useClass: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => { },
            deps: [Sentry.TraceService],
            multi: true,
        },
        providePrimeNG({
            theme: {
                preset: AppPreset,
                options: {
                    darkModeSelector: false
                }
            },
        }),
    ]
})
// CookieService,
// {
//   provide: HTTP_INTERCEPTORS,
//   useClass: AuthInterceptor,
//   multi: true
// }
export class AppModule { }
